import { RawMediaModel } from './cms'
import { LowerCaseBiLingualValue } from 'types/types.ts'

export type Coordinates = {
  lat: number
  long: number
}

export type Image = {
  url?: string
  name?: string
}

export type ImageObject = {
  header?: Image
  profile?: Image
  extra?: Image[]
  logo?: Image
}

type ProducerBase = {
  id: string
  companyDescription: LowerCaseBiLingualValue<string>
  description: LowerCaseBiLingualValue<string>
  enabled: boolean
  facts?: LowerCaseBiLingualValue<string[]>
  images: ImageObject
  longDescription?: LowerCaseBiLingualValue<string>
  name: LowerCaseBiLingualValue<string>
  slug: string
}

type ProducerLocation = {
  coordinates: Coordinates
  currentCapacity: number
  energyType: ProducerEnergyType
  energyUsed: number
  location: LowerCaseBiLingualValue<string>
  maxCapacity: number
  minOccupation: number
  slug: string
  state: ProducerState
}

export type Producer = ProducerBase &
  ProducerLocation & {
    energyRegion: string
    isFeatured: LowerCaseBiLingualValue<boolean>
    isPopular: LowerCaseBiLingualValue<boolean>
    isSoldOut: boolean
    order: number
    parentSlug: string
    salesforceId: string
    website: string
  }

export type ParentProducer = ProducerBase & {
  locations: ProducerLocation[]
}

export enum ProducerEnergyType {
  BIO = 'Bio Energy',
  WATER = 'Water',
  SOLAR = 'Solar',
  WIND = 'Wind'
}

export enum ProducerState {
  AVAILABlE = 'available',
  SOLD_OUT = 'soldOut',
  RESERVED = 'reserved'
}

export type PersonalizedProducers = {
  nl: {
    popular: Producer
    nearest: Producer
    recent: Producer
  }
  fr: {
    popular: Producer
    nearest: Producer
    recent: Producer
  }
}

export type ProducerContact = {
  slug: string
  contactId: string
  firstName: string
  lastName: string
  email: string
  phone: string
  avatar?: RawMediaModel
}
